import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "bold-icon",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.75 1.875C3.40482 1.875 3.125 2.15482 3.125 2.5V17.5C3.125 17.8452 3.40482 18.125 3.75 18.125H12.5C14.9162 18.125 16.875 16.1662 16.875 13.75C16.875 11.8242 15.6308 10.1891 13.9024 9.60459C14.8599 8.80204 15.4688 7.59713 15.4688 6.25C15.4688 3.83375 13.51 1.875 11.0938 1.875H3.75ZM11.0938 9.375C12.8196 9.375 14.2188 7.97589 14.2188 6.25C14.2188 4.52411 12.8196 3.125 11.0938 3.125H4.375V9.375H11.0938ZM4.375 10.625V16.875H12.5C14.2259 16.875 15.625 15.4759 15.625 13.75C15.625 12.0241 14.2259 10.625 12.5 10.625H4.375Z"
    }, null, -1)
  ])))
}
export default { render: render }